module.exports = __webpack_public_path__ + "img/404.031ee082.svg";